<template>
  <Ressincronizacao />
</template>

<script>
import Ressincronizacao from '@/components/utils/documentos/DocRessincronizacao.vue'
export default {
  components: {
    Ressincronizacao,
  },
}
</script>

<style></style>
